import React from "react";
import PropTypes from "prop-types";

import "../styles/patientOverviewRow.scss";

/**
 * The green quote strip between the appointment header and the overview row.
 * Source: Figma 2428:4818 — green@15% fill, 2px #1bc47d border, radius 6.39,
 * SemiBold 14 #26284d centred. Decorative copy that lives in the design, not
 * server data, so the line is the component's default.
 */
const DEFAULT_QUOTE =
  "The good physician treats the disease; the great physician treats the patient who has the disease.";

const QuoteBanner = ({ children }) => (
  <p className="po-quote">{children || DEFAULT_QUOTE}</p>
);

QuoteBanner.propTypes = { children: PropTypes.node };

export default QuoteBanner;
